/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS')
  .directive('agencyOnly', agencyOnly);

agencyOnly.$inject = ['Devise'];
function agencyOnly(Devise) {
  const link = function(scope, elem, attrs) {
    Devise.getCurrentUser()
      .then(function(user) {
      // TODO: fix only show Agency User
        if(!user || !Devise.isMaster()) {
          elem.css({display: 'none'});
        }
      });
  };

  return {
    restrict: 'A',
    link
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/agency_only/agency_only.directive.js